import './CPWD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import {InputValueCopyTo} from 'extensions/input-value-copy-to';

export default class CPWD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		new InputValueCopyTo();

	}

}
